import React from 'react';
import { Col, Container, NavLink, Row } from 'react-bootstrap';
import HospitalDetails  from '../../../HospitalData/HospitalDetails';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer-bg">
            <Container>
                <Row className="text-white">
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Practices</h2>
                            </div>
                            <div className="LinkTitle">
                                <NavLink className="footer-link">For Patients</NavLink>
                                <NavLink className="footer-link">FAQ's</NavLink>
                                <NavLink className="footer-link">About</NavLink>
                                <NavLink className="footer-link">Contact Us</NavLink>
                                <NavLink className="footer-link">Blog</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Resources</h2>
                            </div>
                            <div className="LinkTitle">
                                <NavLink className="footer-link">New Patients</NavLink>
                                <NavLink className="footer-link">Meet the Team</NavLink>
                                <NavLink className="footer-link">Patient Form</NavLink>
                                <NavLink className="footer-link">Insurance</NavLink>
                                <NavLink className="footer-link">Account Login</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Services</h2>
                            </div>
                            <div className="LinkTitle">
                                <NavLink className="footer-link">Cerebral Palsy(C.P)</NavLink>
                                <NavLink className="footer-link">Arthritis</NavLink>
                                <NavLink className="footer-link">Spine disease</NavLink>
                                <NavLink className="footer-link">Cervical problems</NavLink>
                                <NavLink className="footer-link">Frozen shoulder</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Our Address</h2>
                            </div>
                            <div className="LinkTitle">
                                <NavLink className="footer-link">{HospitalDetails.hospitalName}</NavLink>
                                <NavLink className="footer-link">Phone: {HospitalDetails.hospitalPhone}</NavLink>
                                <NavLink className="footer-link">Phone: {HospitalDetails.hospitalPhone2}</NavLink>
                                <NavLink className="footer-link">Email: {HospitalDetails.hospitalEmail}</NavLink>
                                <NavLink className="footer-link">{HospitalDetails.hospitalAddress}</NavLink>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="footer-copy-right text-center text-white">
                <p className='mb-0'>&copy; 2023 - Made with ❤️ by <a href="https://itzabhinavarya.netlify.app" target='_BLANK' rel="noreferrer"><span className="developer">Abhinav Arya</span></a> | All Rights Reserved</p>
            </div>
        </div>
    );
};

export default Footer;